import React from "react";
import AddressController from "../../services/system/address/address-controller";
class AddressManager extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isShowText: true,
            provinceId : "",
            districtId : "",
            wardId : "",
            addressUsually : "",
            listProvince: [],
            listDistrict: [],
            listWard: [],
            onChange: false
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps, nextContext){
        if (this.state.provinceId !==  nextProps.provinceId ||  this.state.districtId !== nextProps.districtId ||  this.state.wardId !== nextProps.wardId){
            this.setState({
                showLoading: true,
                isShowText: nextProps.isShowText === undefined,
                provinceId:  nextProps.provinceId ==null?"":nextProps.provinceId,
                districtId:  nextProps.districtId ==null?"":nextProps.districtId,
                wardId:  nextProps.wardId ==null?"":nextProps.wardId,
                addressUsually:  nextProps.addressUsually,
            }, ()=>{
                this.getListDistrict(this.state.provinceId)
                this.getListWard(this.state.districtId)
            })

        }
    }
    renderProvince = () =>{
        let _province = JSON.parse(localStorage.getItem("province")) ? JSON.parse(localStorage.getItem("province")) : [];
        if (_province.length < 1){
            this.getListProvince()
        }else {
            return _province.map((item, index) => <option value={item.code}>{item.fullName}</option>)
        }
        return ""
    };
    renderDistrict = (provinceId) =>{
        let listItem = this.state.listDistrict.filter(item => item.provinceCode == provinceId)
        if (listItem.length < 1){
            return  ""
        }
        return listItem.map((item, index) => <option
            value={item.code}>{item.fullName}</option>)
    };
    renderWard = (districtId) =>{
        let listItem = this.state.listWard.filter(item => item.districtCode == districtId)
        if (listItem.length < 1){
            return  ""
        }
        return listItem.map((item, index) => <option
            value={item.code}>{item.fullName}</option>)
    };
    getListWard = (districtId) =>{
        let payloadWard = {
            "pageNumber": 0,
            "pageSize": 1000,
            "districtCode":districtId,
            "sort": ""
        }
        AddressController.getAllWard(payloadWard, res => {
            if (res.success) {
                if (res.data.content.length > 0){
                    this.setState({
                        listWard: res.data.content
                    }, () =>{
                        this.props.onUpdateAddress(this.state.addressUsually, this.state.wardId, this.state.districtId, this.state.provinceId)
                    })
                }
            }
        });
    }
    getListDistrict = (provinceCode) =>{
        let payloadDistrict = {
            "pageNumber": 0,
            "pageSize": 1000,
            "provinceCode":provinceCode,
            "sort": ""
        }
        AddressController.getAllDistrict(payloadDistrict, res => {
            if (res.success) {
                if (res.data.content.length > 0){
                    this.setState({
                        listDistrict: res.data.content
                    }, () =>{
                        this.props.onUpdateAddress(this.state.addressUsually, this.state.wardId, this.state.districtId, this.state.provinceId)
                    })
                }
            }
        });
    }
    getListProvince = () =>{
        let payload = {
            "pageNumber": 0,
            "pageSize": 1000,
            "sort": ""
        }
        AddressController.getAllProvince(payload, res => {
            if (res.success) {
                localStorage.setItem("province", JSON.stringify(res.data.content))
                if (res.data.content.length > 0){
                    this.setState({
                        provinceId: res.data.content[0]?.code,
                        listProvince: res.data.content
                    }, () =>{
                        this.props.onUpdateAddress(this.state.addressUsually, this.state.wardId, this.state.districtId, this.state.provinceId)
                    })
                }
            }
        });
    }
    onChangeProvince = (e) => {
        this.setState({
            wardId: "",
            districtId: "",
            provinceId: e.target.value,
            listWard: [],
            onChange: true
        }, () =>{
            this.props.onUpdateAddress(this.state.addressUsually, this.state.wardId, this.state.districtId, this.state.provinceId)
        })
        this.getListDistrict(e.target.value)
    };
    onChangeDistrict = (e) => {
        this.setState({
            wardId: "",
            listWard: [],
            districtId: e.target.value,
        }, () =>{
            this.props.onUpdateAddress(this.state.addressUsually, this.state.wardId, this.state.districtId, this.state.provinceId)
        })
        this.getListWard(e.target.value)
    };
    onChangeWard = (e) => {
        this.setState({
            wardId: e.target.value
        }, () =>{
            this.props.onUpdateAddress(this.state.addressUsually, this.state.wardId, this.state.districtId, this.state.provinceId)
        })
    };
    render() {
        let {provinceId, districtId, wardId, addressUsually}  = this.state
        return (
            <div className="row col-12" style={{
                paddingRight: 0,
                paddingLeft: 0,
                marginLeft: "0px !important",
                marginRight: "0px !important",
            }}
            >
                <div className="col-md-6 col-xs-12 d-flex mb-2">
                    <label className="col-md-4 col-xs-12 label-item pl-0" style={{display: this.state.isShowText ? 'block' : 'none' }}>Địa chỉ(<span  style={{color: "red",}}>*</span>)</label>
                    <input
                        maxLength={255}
                        type="text"
                        placeholder="Nhập địa chỉ"
                        className={this.state.addressErr ? "form-control border-input-error kt-input pd-4-input hei-input" : "form-control kt-input pd-4-input hei-input"}
                        value={addressUsually}
                        onChange={(val) => this.setState({
                            addressUsually: val.target.value.trimLeft(),
                            inEditing: true
                        }, () => {
                            this.state.addressUsually.length === 0 ? this.setState({
                                addressErr: true,
                                btnSaveStatus: false
                            }) : this.setState({
                                addressErr: false,
                                btnSaveStatus: true
                            })
                            this.props.onUpdateAddress(this.state.addressUsually, this.state.wardId, this.state.districtId, this.state.provinceId)
                        })}
                    />
                </div>
                <div className="col-md-6 col-xs-12 d-flex mb-2">
                    <label className="col-md-4 col-xs-12 label-item pl-0" style={{display: this.state.isShowText ? 'block' : 'none' }}>Tỉnh/TP</label>
                    <select
                        className="form-control kt-input pd-4-input hei-input"
                        value={provinceId}
                        onChange={this.onChangeProvince}
                    >
                        <option value="">Chọn Tỉnh/Thành Phố</option>
                        {this.renderProvince()}
                    </select>
                </div>

                <div className="col-md-6 col-xs-12 d-flex mb-2">
                    <label className="col-md-4 col-xs-12label-item pl-0" style={{display: this.state.isShowText ? 'block' : 'none' }}>Quận huyện</label>
                    <select
                        className="form-control kt-input pd-4-input hei-input"
                        value={districtId}
                        onChange={this.onChangeDistrict}
                    >
                        <option value="">Chọn quận huyện</option>
                        {this.renderDistrict(provinceId)}
                    </select>
                </div>
                <div className="col-md-6 col-xs-12 d-flex mb-2">
                    <label className="col-md-4 col-xs-12 label-item pl-0" style={{display: this.state.isShowText ? 'block' : 'none' }}>Xã phường</label>
                    <select
                        className="form-control kt-input pd-4-input hei-input"
                        value={wardId}
                        onChange={this.onChangeWard}
                    >
                        <option value="">Chọn xã phường</option>
                        {this.renderWard(districtId)}
                    </select>
                </div>
            </div>
        );
    }
}
export default AddressManager;
